import { bigColorfulConsoleLog } from "../request/helpers/big-colorful-console-log"
import { 
    RequestInformation,
    ProviderUsageResult,
    AmountUsage
} from "../types"
import { Model } from "../types/model-types"
import { PricingCore } from "./pricing-core"




export async function calculateFalUsage({
    responseAPI,
    model
}: {
    responseAPI: RequestInformation['responseAPI']
    model: Model
}) {
    // FAL: calculate by images count, megapixels, and/or compute seconds
    const result = responseAPI || {}
    const queue = result.queue || {}
    const images: any[] = Array.isArray(result?.images) ? result.images : []
    const imageCount = images.length

    // Try to infer image size (if available) for megapixel calculation
    // Fallback to 1 MP if unknown
    const pixelsPerImage = (() => {
        const fromMeta = images?.[0]?.width && images?.[0]?.height
            ? (images[0].width * images[0].height)
            : undefined
        return fromMeta || (1024 * 1024) // default ~1MP
    })()
    const totalMegapixels = (pixelsPerImage * Math.max(1, imageCount)) / (1024 * 1024)

    // Compute seconds from queue metrics if present
    const computeSeconds = (() => {
        const seconds = queue?.metrics?.inference_time
        if (typeof seconds === 'number') return seconds
        // inference_time may be in seconds; if ms provided elsewhere, adjust here
        return undefined
    })()

    // Pricing composition
    const pricePerImage = model.pricing.output_image || 0
    const pricePerMp = model.pricing.output_image_mp || 0
    const pricePerSecond = model.pricing.output_compute_second || 0

    const outputImageCost = pricePerImage * imageCount
    const outputMpCost = pricePerMp * totalMegapixels
    const outputComputeCost = computeSeconds ? (pricePerSecond * computeSeconds) : 0
    const totalCost = outputImageCost + outputMpCost + outputComputeCost

    const providerUsage: ProviderUsageResult['providerUsage'] = {
        outputImages: imageCount,
        outputMegapixels: totalMegapixels,
    }

    const amountUsage: AmountUsage = {
        inputAmount: 0,
        outputAmount: totalCost,
        totalAmount: totalCost,
        profitMultiplier: 1.3,
    }

    const metadata = {
        imageCount,
        totalMegapixels,
        computeSeconds,
        calculatedOutputImageAmount: outputImageCost,
        calculatedOutputMegapixelAmount: outputMpCost,
        calculatedOutputComputeAmount: outputComputeCost,
        modelPricing: model.pricing,
    }

    bigColorfulConsoleLog('fal usage')
    console.log('\x1b[36m%s\x1b[0m', 'fal usage', {
        amountUsage,
        providerUsage,
        metadata,
    })

    return {
        amountUsage,
        providerUsage,
        metadata,
    }
}